import React from 'react';
import {ReactComponent as Plus} from '../../assets/icons/plus.svg';
import {ReactComponent as Minus} from '../../assets/icons/minus.svg';
import {Box, Button, Input, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {isMobile} from "react-device-detect";
import {SellingUnitDto} from "../../dtos/flyer";
import tinycolor from "tinycolor2";
import {StoreProjectDto} from "../../dtos/siteDto";

const useStyles = makeStyles(() => ({
    counterBox: {
        display: `flex`,
        justifyContent: 'center',
        alignItems: 'center',
        height: `inherit`,
        '& .MuiButton-root': {
            '&.Mui-disabled': {
                '& > svg': {
                    opacity: '0.5'
                }
            }
        }
    },

    counterWrapper: (props: any) => ({
        backgroundColor: props.color ? `${props.color}4D` : '#C32E4333',
        direction: 'rtl',
        height: `inherit`,
        borderRadius: `4px`,
        width: `100%`,
        display: 'flex',
        // borderTop: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}!important` : `1px solid #ffffff!important`,
        // borderBottom: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}!important` : `1px solid #ffffff!important`,
        "& .MuiTypography-root": {
            textAlign: 'center!important',
            lineHeight: `13px`,
            fontFamily: props.fontFamily,
            direction: props.direction
        },
    }),
    countInput: {
        flex: "1 1 auto",
        // borderTop: "1px solid transparent",
        // borderBottom: "1px solid transparent",
        padding: "0 4px"
    },
    countBtn: (props: any) => ({
        '&.MuiButton-root': {
            padding: props.widthPXForBtn === "40px" ? '12px' : "6px",
            width: props.widthPXForBtn ? props.widthPXForBtn : `28px`,
            height: `inherit`,
            zIndex: 1,
            backgroundColor: props.color ? `${props.color}CC!important` : '#C32E4333',
            outline: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}!important` : `1px solid #ffffff!important`,
            borderRadius: `4px`,
            '&:disabled': {
                opacity: `50%`,
            },
            '& svg path': {
                fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                // fill: props.color ? `${props.color}` : '#C32E4333',
                // stroke: props.color ? `${props.color}` : '#C32E4333'
            }
        },
        '&.MuiButton-root:not(.isMobile)': {
            // height: '40px',
            // minHeight: `23px`,
            // padding: '5px 5px',
            '&:hover': {
                outline: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}!important` : `1px solid #ffffff!important`,
                backgroundColor: props.color ? `${props.color}!important` : '#C32E4333',
                '& svg path': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            },
            '&:active': {
                outline: props.isLightGuiColor ? `1px solid ${props.fontsGuiColor}!important` : `1px solid #ffffff!important`,
                backgroundColor: props.color ? `${props.color}!important` : '#C32E4333',
                '& svg path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            },
        }
    })
}))

type Props = {
    count: string | number;
    // isHebrewStyle: boolean;
    increase: (e: React.MouseEvent<HTMLButtonElement>) => void;
    decrease: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onChangeCountNumber?: (value: string) => void;
    isBasket: boolean;
    promotionSellingUnit?: SellingUnitDto;
    widthPXForBtn?: string;
}

export const Counter: React.FC<Props> = ({
                                             count,
                                             decrease,
                                             increase,
                                             isBasket,
                                             promotionSellingUnit,
                                             widthPXForBtn,
                                             onChangeCountNumber = () => {}
                                         }) => {
    const storeGlobalData = useSelector<IAppState, StoreProjectDto | null>((state) => state.storeData);
    const flyerBranch = useSelector((state: IAppState) => state.flyersBranch.data);
    const storeData = useSelector((state: IAppState) => state.shelvesScreen.data);
    const settingForPopup = storeGlobalData?.isFromFlyer ? flyerBranch : storeData?.storeSetting;
    const isLightGuiColor = tinycolor(settingForPopup?.primaryColorRgb || "#C32E43").isLight();
    const fontsGuiColor = settingForPopup?.fontsColorRgb || "#000000";
    // const [isDebouncing, setIsDebouncing] = useState<boolean>(false);
    // const debouncingTime = 200;

    const stylesProperties = {
        fontFamily: settingForPopup?.font?.toLocaleLowerCase() || "roboto",
        color: settingForPopup?.primaryColorRgb ? settingForPopup?.primaryColorRgb : `#C32E43`,
        direction: settingForPopup?.dir?.toLocaleLowerCase() || "ltr",
        isMobile: isMobile,
        widthPXForBtn: widthPXForBtn,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const isShowSellingUnit = promotionSellingUnit && promotionSellingUnit?.id !== 1 && promotionSellingUnit?.id !== 8 && promotionSellingUnit?.id !== 23
    const classes = useStyles(stylesProperties);
    let allowedProps: any = {
        "data-currency-code": settingForPopup?.currencyAbbrv || "USD",
    };
    const plusBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
        // if (!isDebouncing) {
        //     setIsDebouncing(true);
        increase(e);
        //     setTimeout(function() {
        //         setIsDebouncing(false);
        //     }, debouncingTime); // set the debounce time (in milliseconds)
        // }
    }
    const minusBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
        // if (!isDebouncing) {
        //     setIsDebouncing(true);
        decrease(e);
        //     setTimeout(function() {
        //         setIsDebouncing(false);
        //     }, debouncingTime); // set the debounce time (in milliseconds)
        // }
    }

    const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value === "" ? "0" : e.target.value === "." ? "0." : e.target.value;
        onChangeCountNumber(value);
    }

    const onBlur = (e: any) => {
        const value = e.target.value === "" || e.target.value === "." ? "0" : e.target.value;
        onChangeCountNumber(Number(value).toString());

    }
    return (
        <Box className={`${classes.counterWrapper} ${classes.counterBox}`}>
            <Box className={`${classes.counterBox} plus_wrapper_btn`} justifyContent={'flex-start'} {...allowedProps}>
                <Button onClick={plusBtn} className={`${isMobile ? `isMobile` : ``} ${classes.countBtn}`}
                        disabled={Number(count) === (promotionSellingUnit ? promotionSellingUnit?.maxQty : 99)}
                >
                    <Plus style={{width: "100%", height: "100%"}}/>
                </Button>
            </Box>

            <Box className={`${classes.counterBox} ${classes.countInput}`}>
                {/*<Typography*/}
                {/*    className={'item_quantity'}*/}
                {/*    fontSize={isMobile ? `16px` : `16px`}>*/}
                {/*    {count > 0 ? count : ``}{isShowSellingUnit ? ` ${promotionSellingUnit?.languageAbbrv}` : ``}*/}
                {/*</Typography>*/}
                <Input
                    startAdornment={
                        <>
                            {
                                isShowSellingUnit &&
                                <Typography
                                    className={"selling_unit_abbr"}
                                    align={"center"}
                                    sx={{
                                        // maxWidth: "100%",
                                        // width: "inherit",
                                        paddingLeft: "4px",
                                        width: "auto",
                                        whiteSpace: "nowrap"
                                    }}
                                    fontSize={isMobile ? `16px` : `16px`}>
                                    {isShowSellingUnit ? `${promotionSellingUnit?.languageAbbrv}` : ``}
                                </Typography>
                            }
                        </>
                    }
                    onChange={onChangeInput}
                    onBlur={onBlur}
                    className={'item_quantity'}
                    value={count}
                    sx={{
                        // padding: "4px",
                        fontSize: "16px",
                        maxHeight: "100%",
                        width: "100%",
                        maxWidth: "100px",
                        // width: "24%",
                        "& > input": {
                            padding: widthPXForBtn === "40px" ? "4px" : "0",
                            lineHeight: "1",
                            height: "22px",
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            direction: settingForPopup?.dir?.toLowerCase() === "rtl" ? "rtl" : "ltr",
                            border: isLightGuiColor ? `1px solid ${fontsGuiColor}!important` : `1px solid #ffffff!important`,
                        }
                    }}
                    disableUnderline
                />
            </Box>
            <Box className={`${classes.counterBox} minus_wrapper_btn`} justifyContent={'flex-end'} {...allowedProps}>
                <Button onClick={minusBtn} className={`${isMobile ? `isMobile` : ``} ${classes.countBtn}`}
                        disabled={Number(count) === 0 || (isBasket && (Number(count) === (promotionSellingUnit ? promotionSellingUnit?.guiIncrement : 1)))}>
                    <Minus style={{width: "100%", height: "100%"}}/>
                </Button>
            </Box>
        </Box>
        // <div className={`${styles.container} ${isHebrewStyle ? styles.hebrewStyle : ''}`}>
        //     <button onClick={decrease}>
        //         <Minus />
        //     </button>
        //     <span>
        //         {count}
        //     </span>
        //     <button onClick={increase}>
        //         <Plus />
        //     </button>
        // </div>

    )

}
